import React from 'react';
import { ShieldCheckIcon, GlobeIcon, FlameIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { offerRows } from '../../data/content';
export function Offer() {
  return <section id="offerta" className="bg-ink-900 px-4 py-12 sm:py-16" data-id="element-141" data-mp="305ptaeo0k3lu">
      <div className="mx-auto max-w-2xl" data-id="element-142" data-mp="356m318v1qjz6">
        <div className="flex justify-center" data-id="element-143" data-mp="3549doamyl7c3">
          <span className="rounded-full bg-alert-500/15 px-3.5 py-1.5 text-[11px] font-black uppercase tracking-[0.14em] text-alert-500" data-id="element-144" data-mp="3a68jdr668gc7">
            💰 Offerta speciale
          </span>
        </div>

        <h2 className="mt-4 text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-145" data-mp="3jv05hiojw6f7">
          Tutto quello che riceverai oggi
        </h2>

        <div className="mt-6 overflow-hidden rounded-3xl border border-white/10 bg-ink-800" data-id="element-146" data-mp="3nyofs94khg45">
          <div className="flex items-center justify-between border-b border-white/10 bg-ink-700 px-4 py-3" data-id="element-147" data-mp="3stu1p7xyyus8">
            <span className="text-[11px] font-black uppercase tracking-[0.14em] text-white/50" data-id="element-148" data-mp="1natm0jipixm">
              Include
            </span>
            <span className="text-[11px] font-black uppercase tracking-[0.14em] text-white/50" data-id="element-149" data-mp="1fm3y1y04l3gr">
              Valore
            </span>
          </div>
          <ul data-id="element-150" data-mp="1bmwby9b8nf8b">
            {offerRows.map(row => <li key={row.name} className="flex items-center justify-between gap-3 border-b border-white/5 px-4 py-3" data-id="element-151" data-mp="16mqnt346gauz">
                <span className="text-[14px] font-semibold leading-snug text-white/85" data-id="element-152" data-mp="1zamki7tqy2rr">
                  {row.name}
                </span>
                <span className={`shrink-0 text-[13px] font-bold ${row.value === 'Incluso' ? 'text-brand-400' : 'text-white/50 line-through'}`} data-id="element-153" data-mp="1uicw4w8a5arl">
                  {row.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between gap-3 bg-ink-700 px-4 py-3.5" data-id="element-154" data-mp="2i7xilp3n6q5m">
            <span className="text-[13px] font-black uppercase tracking-wide text-white" data-id="element-155" data-mp="3160lnk79k270">
              Valore totale di riferimento
            </span>
            <span className="font-display text-xl text-white/40 line-through" data-id="element-156" data-mp="2sdoziaj6n0wu">€282</span>
          </div>
        </div>

        <div className="mt-6 rounded-3xl border-2 border-brand-500/60 bg-ink-800 p-5 text-center shadow-[0_0_60px_-25px_rgba(23,195,178,0.9)]" data-id="element-157" data-mp="2wdz7ttug63ev">
          <p className="text-[14px] leading-relaxed text-white/60" data-id="element-158" data-mp="2ih2hrum5kpz1">
            Oggi non pagherai <span className="line-through" data-id="element-159" data-mp="2nfdp9yoz6oe3">€282</span>.
            <br data-id="element-160" data-mp="29et9lbecx8ot" />E non pagherai nemmeno <span className="line-through" data-id="element-161" data-mp="29fmdm4lxlk39">€97</span>.
          </p>

          <p className="mt-4 text-[11px] font-black uppercase tracking-[0.18em] text-brand-400" data-id="element-162" data-mp="2dfd2u3vt7s5o">
            Accesso immediato a soli
          </p>
          <p className="font-display text-[64px] leading-none text-white sm:text-7xl" data-id="element-163" data-mp="7npry261utur">€19</p>
          <p className="mt-2 text-[13px] font-medium text-white/60" data-id="element-164" data-mp="bnqk0pm2n3ka">
            Pagamento unico • Nessun abbonamento • Accesso a vita
          </p>

          <div className="mt-4 flex items-start gap-2 rounded-2xl border border-white/10 bg-ink-900 p-3 text-left" data-id="element-165" data-mp="1s5ikbdnnixvx">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-166" data-mp="25wnfa2g2r1zx" />
            <p className="text-[12.5px] leading-snug text-white/60" data-id="element-167" data-mp="215f00ps2cmeu">
              <strong className="font-bold text-white" data-id="element-168" data-mp="2fujk6cif50pl">Cambio valuta automatico:</strong> il
              prezzo viene convertito automaticamente nella valuta del tuo paese al momento
              del pagamento.
            </p>
          </div>

          <div className="mt-5" data-id="element-169" data-mp="2otyanbyl5ba3">
            <CTAButton label="Voglio il Sistema Anti-Rifiniture™" sublabel="Download immediato" data-id="element-170" data-mp="2ot59qrmb5fzv" />
          </div>

          <div className="mt-5" data-id="element-171" data-mp="ui9rexlbmmjw">
            <Countdown data-id="element-172" data-mp="uhgsujwin3cu" />
          </div>
        </div>

        <div className="mt-6 rounded-3xl border border-alert-500/35 bg-alert-500/5 p-4" data-id="element-173" data-mp="pix5qg66rliw">
          <div className="flex items-center gap-2" data-id="element-174" data-mp="rxbr3cvacuc0">
            <FlameIcon className="h-5 w-5 shrink-0 text-alert-500" aria-hidden="true" data-id="element-175" data-mp="rwiw195ovt9p" />
            <h3 className="text-[15px] font-black uppercase tracking-wide text-alert-500" data-id="element-176" data-mp="vwszof60e7le">
              Posti quasi esauriti!
            </h3>
          </div>
          <p className="mt-2 text-[13.5px] leading-relaxed text-white/70" data-id="element-177" data-mp="15x3bbvceb6yg">
            Mancano solo <strong className="font-black text-white" data-id="element-178" data-mp="89321bp1h4gq">7 accessi</strong> al
            prezzo promozionale di oggi prima della chiusura dell’offerta.
          </p>
          <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-ink-800" role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Posti occupati" data-id="element-179" data-mp="d85yi7qye2d3">
            <div className="h-full w-[93%] rounded-full bg-alert-500" data-id="element-180" data-mp="3lmwle6wkuxaj" />
          </div>
          <div className="mt-2 flex items-center justify-between text-[11px] font-bold uppercase tracking-wide" data-id="element-181" data-mp="3qlr2n4ewcdsj">
            <span className="text-alert-500" data-id="element-182" data-mp="3j1yo6v1u9l6v">93 posti su 100 occupati</span>
            <span className="text-white/50" data-id="element-183" data-mp="3e3x364kurbsr">Restano 7 cupos</span>
          </div>
        </div>

        <div className="mt-6 rounded-3xl border border-brand-500/30 bg-ink-800 p-5" data-id="element-184" data-mp="394kf5gi8vyol">
          <div className="flex items-center gap-2.5" data-id="element-185" data-mp="34696h93oru7y">
            <ShieldCheckIcon className="h-7 w-7 shrink-0 text-brand-400" aria-hidden="true" data-id="element-186" data-mp="345r2trep2dq0" />
            <h3 className="font-display text-lg text-white" data-id="element-187" data-mp="305yqd3m6jnfd">Garanzia di 7 Giorni</h3>
          </div>
          <p className="mt-3 text-[14px] leading-relaxed text-white/70" data-id="element-188" data-mp="2vc4daj12y6p9">
            Vogliamo che tu possa esaminare il materiale con tranquillità. Se durante i primi
            7 giorni ritieni che il Sistema Anti-Rifiniture™ non soddisfi le tue aspettative,
            scrivici e procederemo con il rimborso.{' '}
            <strong className="font-bold text-white" data-id="element-189" data-mp="2giivl3xpgulc">Senza complicazioni.</strong>
          </p>
        </div>
      </div>
    </section>;
}